import { Check, Close } from "@mui/icons-material";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default ({
  enabled, titleEnabled = "", titleDisabled = "", disabled = false, buttonSize = "medium", fontSize = "small",
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (enabled === true) {
    return (
      <Tooltip title={t(titleEnabled)} placement="bottom" disableTouchListener>
        <div style={{ display: "inline-flex" }}>
          <IconButton disabled={disabled} size={buttonSize}>
            <Check fontSize={fontSize} style={{ color: theme.palette.success.light }} />
          </IconButton>
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t(titleDisabled)} placement="bottom" disableTouchListener>
      <div style={{ display: "inline-flex" }}>
        <IconButton disabled={disabled} size={buttonSize}>
          <Close fontSize={fontSize} style={{ color: theme.palette.error.light }} />
        </IconButton>
      </div>
    </Tooltip>
  );

};
